// extracted by mini-css-extract-plugin
export default {"container":"Paragraph_container__baCSn","label":"Paragraph_label__IkRQv","formHelperText":"Paragraph_formHelperText__+Xv5+"};